import dayjs from 'dayjs';
import React from 'react';
import styled from "styled-components";
import { navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const BlogCardWrapper = styled.div`
    width: 100%;
    max-width: 320px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
        display: grid;
        grid-template: 1fr / 1fr 0.3fr;
        height: 170px;
        grid-column-gap: 16px;
        max-width: 100%;
        border: none;
        box-shadow: none;
        border-radius: 8px;
        background-color: transparent;

        &:hover {
            transform: none;
            box-shadow: none;
        }
    }
`

const BlogCardImgContainer = styled.div`
    width: 100%;
    height: 180px;

    @media (max-width: 768px) {
        grid-column: 2/3;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`
const BlogCardImg = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
    display: block;

    @media (max-width: 768px) {
        height: 100px;
        margin-top: 46px;
        border-radius: 6px;
    }

    @media (max-width: 500px) {
        margin: 0;
        height: 65px;
        margin-top: 20px;
    }

`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 20px 16px 20px;
    flex: 1;

    @media (max-width: 768px) {
        grid-column: 1/2;
        grid-row: 1/2;
        padding: 0;
    }
`

const Subtitle = styled.p`
    font-size: 12px;
    color: #4fbc61;
    font-weight: 500;
    margin: 0;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    @media (max-width: 768px) {
        margin-bottom: 6px;
        text-transform: none;
        letter-spacing: 0;
        margin-top: 16px;
    }
`

const Title = styled.h4`
    color: black;
    margin: 0;
    margin-bottom: 10px;
    font-size: 18px;
    line-height: 24px;

    @media (max-width: 768px) {
        margin: 0;
    }
 `

const Text = styled.p`
    color: rgba(60, 60, 60, 1);
    font-size: 14px;
    line-height: 22px;
    overflow: hidden;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    @media (max-width: 500px) {
        display: none !important;
    }
`
const CardFooter = styled.div`
    color: rgba(117, 117, 117, 1);
    font-size: 12px;
    padding: 0 20px 20px 20px;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        padding: 8px 0 0 0;
    }
`
const Tag = styled.span`
    background-color: rgba(79, 188, 97, 0.12);
    border-radius: 18px;
    padding: 4px 10px;
    margin-right: 12px;
    color: #4fbc61;
    font-weight: 500;
`
const BlogPostCard = ({ post }) => {
    const { t } = useTranslation();
    return (
        <BlogCardWrapper onClick={() => navigate(`/posts/${post?.slug}`)}>
            <BlogCardImgContainer>
                <BlogCardImg  src={post?.coverImage?.url} />
            </BlogCardImgContainer>

            <TextContainer>
                <Subtitle>{dayjs(post.date).format("MMMM DD, YYYY")}{post.author?.name ? ` — ${post.author.name}` : ''}</Subtitle>
                <Title>{post?.title}</Title>
                <Text>{post?.excerpt}</Text>
            </TextContainer>

            <CardFooter>
                {post?.tags?.[0] && <Tag>{post.tags[0]}</Tag>}
                {post?.timeToRead} {t("blog.min.read")}
            </CardFooter>
        </BlogCardWrapper>
    )
}


export default BlogPostCard;